const LEFT_ODD = [
  '0001101',
  '0011001',
  '0010011',
  '0111101',
  '0100011',
  '0110001',
  '0101111',
  '0111011',
  '0110111',
  '0001011',
];
const LEFT_EVEN = [
  '0100111',
  '0110011',
  '0011011',
  '0100001',
  '0011101',
  '0111001',
  '0000101',
  '0010001',
  '0001001',
  '0010111',
];
const RIGHT = [
  '1110010',
  '1100110',
  '1101100',
  '1000010',
  '1011100',
  '1001110',
  '1010000',
  '1000100',
  '1001000',
  '1110100',
];
const PARITY = [
  'LLLLLL',
  'LLGLGG',
  'LLGGLG',
  'LLGGGL',
  'LGLLGG',
  'LGGLLG',
  'LGGGLL',
  'LGLGLG',
  'LGLGGL',
  'LGGLGL',
];

const checkDigitFor = (twelveDigits: string): string => {
  let sum = 0;
  for (let position = 0; position < 12; position += 1) {
    sum += Number(twelveDigits[position]) * (position % 2 === 0 ? 1 : 3);
  }
  return String((10 - (sum % 10)) % 10);
};

export const thirteenDigitBarcode = (barcode: string): string | null => {
  const digits = barcode.trim();
  if (/^\d{12}$/.test(digits)) return digits + checkDigitFor(digits);
  return /^\d{13}$/.test(digits) ? digits : null;
};

const barcodeBits = (code: string): string => {
  const leadingDigit = Number(code[0]);
  let bits = '101';
  for (let position = 1; position <= 6; position += 1) {
    const digit = Number(code[position]);
    bits +=
      PARITY[leadingDigit][position - 1] === 'L'
        ? LEFT_ODD[digit]
        : LEFT_EVEN[digit];
  }
  bits += '01010';
  for (let position = 7; position <= 12; position += 1) {
    bits += RIGHT[Number(code[position])];
  }
  return `${bits}101`;
};

export interface Ean13BarcodeProps {
  barcode: string;
  className?: string;
}

export function Ean13Barcode({ barcode, className = '' }: Ean13BarcodeProps) {
  const code = thirteenDigitBarcode(barcode);
  if (!code) return null;

  const bits = barcodeBits(code);
  const moduleWidth = 2;
  const barHeight = 44;
  const guardHeight = 52;

  return (
    <svg
      className={className}
      viewBox={`0 0 ${bits.length * moduleWidth} ${guardHeight}`}
      width='190'
      height='52'
      role='img'
      aria-label={`Barcode ${code}`}
    >
      {[...bits].map((bit, index) =>
        bit === '1' ? (
          <rect
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            x={index * moduleWidth}
            y={0}
            width={moduleWidth}
            height={
              index < 3 ||
              (index >= 45 && index < 50) ||
              index >= bits.length - 3
                ? guardHeight
                : barHeight
            }
            fill='#101828'
          />
        ) : null
      )}
    </svg>
  );
}
